import { render, staticRenderFns } from "./kitchen-display.vue?vue&type=template&id=942e5af6"
import script from "./kitchen-display.vue?vue&type=script&lang=js"
export * from "./kitchen-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports